import React, { useState, useEffect } from "react";
import { Result, Button, Card } from "antd";
import { Link } from 'react-router-dom';
import routes from "../../../const/routes";

function RoomLive({props}){
    let [ valid, setValid ] = useState(true);

    setInterval(() => { 
        if(valid !== props.validVoucher(props.voucher)){
            setValid(valid = props.validVoucher(props.voucher)) 
        }
    }, 300000);

    useEffect(() => {
        setValid(valid = props.validVoucher(props.voucher))
    }, []);

    return(            
        <header className="v-header container">
           
            <div className="fullscreen-video-wrap">
                <img alt="" style={{width: "100%"}} src={require("../../../img/background.jpg")}/>
            </div>
            <div className="header-overlay"></div>
            <div className="App-header">
                {
                        !valid ? 
                            <Card 
                                style={{ 
                                    borderRadius: 45,
                                    width: "80%",
                                    height: "85%"
                                }}
                                className="cardLogin"
                            >
                                <Result
                                    style={{
                                        display: "block", margin: "auto", width: "80%", marginTop: 40, background: "#fff"}} 
                                    status="404"
                                    title="404"
                                    subTitle="Esse voucher não é mais valido."
                                    extra={
                                        <Link to={routes.BEGIN}>
                                            <Button type="primary">Voltar ao Inicio</Button>
                                        </Link>
                                    }
                                />
                            </Card>
                        :
                            <div style={{width: "90%", height:"90%", marginTop: 20}}>
                                
                                <iframe 
                                    title="video"
                                    src={props.voucher[0].room_info[0].link}
                                    width="100%" 
                                    height="100%" 
                                    frameBorder="0" 
                                    allowFullScreen
                                ></iframe>
                            </div>
                    } 
            </div>
        </header>
    )
}

export default RoomLive;


// WEBPACK FOOTER //
// ./src/components/general/roomLiveWrapper/RoomLive.jsx